import {
  simulateSpecialsLaunch,
  simulateSpecialsRemove,
} from '../../features/simulateSpecials/launcher';
import logger from '../../shares/lib/logger';

export const SimulateSpecials = {
  launch: async (): Promise<void> => {
    try {
      await simulateSpecialsLaunch();
    } catch (error) {
      logger.error('Simulate Specials launch error', { error });
      throw error;
    }
  },

  remove: async (): Promise<void> => {
    try {
      await simulateSpecialsRemove();
    } catch (error) {
      logger.error('Simulate Specials remove error', { error });
      throw error;
    }
  },
};
